
export const PAGE_ROUTES = {
  HOME: "/",
  SERVICES: "/services",
  TERMS: "/terms-and-conditions",
  PRIVACY: "/privacy-policy",
};

//Sections of the home page that the nav links scroll to
export const HOME_SECTIONS = {
  ABOUT: "/#about",
  CONTACT: "/#contact",
};

export const CONTACT_DETAILS = {
  EMAIL: "janine@jb-inc.co.za",
  PHONE: "+27 82 325 4156",
  PHONE_LINK: "tel:+27823254156",
  //The firm has no social profiles, so the icons are hidden (the old Wix site linked to the generic home pages).
  //Add a profile URL here to show its icon in the header & footer
  INSTAGRAM: "",
  FACEBOOK: "",
};

export const PAIA_MANUAL = "/docs/paia-manual.pdf";

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  CONTACT_SEND: "ls_1",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};
